(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{if(event.target.matches('.oh-localization select'))event.target.form.requestSubmit()});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change',event=>{if(!event.target.matches('.oh-bundles input'))return;const root=event.target.closest('[data-oh-product]');root.querySelectorAll('[data-oh-price]').forEach(el=>el.textContent=event.target.dataset.price);root.querySelectorAll('button[type="submit"]').forEach(button=>button.disabled=event.target.dataset.available!=='true');const url=new URL(location.href);if(location.pathname.includes('/products/')){url.searchParams.set('variant',event.target.value);history.replaceState({},'',url)}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oh2-media"] && !Shopify.designMode) return;
  try {
    
(() => {
  const cleanups = new WeakMap();
  const update = section => {
    const track = section.querySelector('[data-o-video-track]');
    section.querySelector('[data-o-video-step="-1"]').disabled = track.scrollLeft <= 2;
    section.querySelector('[data-o-video-step="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  };
  const init = root => {
    root.querySelectorAll('[data-o-video-section]').forEach(section => {
      if (cleanups.has(section)) return;
      const track = section.querySelector('[data-o-video-track]');
      const videos = [...track.querySelectorAll('video')];
      const onScroll = () => update(section);
      track.addEventListener('scroll', onScroll, { passive: true });
      const resize = new ResizeObserver(onScroll);
      resize.observe(track);
      let playback;
      if (section.dataset.autoplay === 'true') {
        playback = new IntersectionObserver(entries => {
          entries.forEach(({ target: video, isIntersecting, intersectionRatio }) => {
            if (isIntersecting && intersectionRatio >= 0.35) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.35] });
        videos.forEach(video => {
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;
          playback.observe(video);
        });
      }
      cleanups.set(section, () => {
        resize.disconnect();
        playback?.disconnect();
        videos.forEach(video => video.pause());
        track.removeEventListener('scroll', onScroll);
        cleanups.delete(section);
      });
      update(section);
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-o-video-step]');
    if (!button) return;
    const track = button.closest('[data-o-video-section]').querySelector('[data-o-video-track]');
    const cards = track.querySelectorAll('article');
    const distance = cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : track.clientWidth;
    track.scrollBy({ left: distance * Number(button.dataset.oVideoStep), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-o-video-section]').forEach(section => cleanups.get(section)?.());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
})();

  } catch(e) { console.error(e); }
})();
})();
